import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import HOT_ICON from "@/assets/images/hot.svg";

export default function MatchLeagues({ league, matches, render }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const name = league?.nameVN ?? league?.name ?? "";

  return (
    <div className="kbv-ltd-league-group flex flex-col min-h-0">
      <div className="kbv-ltd-league-head">
        <button
          type="button"
          className="kbv-ltd-league-head-btn"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <div className="flex min-w-0 flex-1 items-center gap-1">
            {league?.logo ? (
              <img
                src={league.logo}
                alt=""
                className="w-5 h-5 object-contain shrink-0"
                width={20}
                height={20}
              />
            ) : (
              <span className="w-5 h-5 shrink-0" />
            )}
            <span className="truncate text-sm font-semibold text-[var(--theme-text)]">
              {name}
            </span>
            {league?.isHot ? (
              <img src={HOT_ICON} alt="HOT" width={50} height={18} className="h-[18px] w-[50px] shrink-0" />
            ) : null}
          </div>
          <img
            className={`kbv-ltd-chevron w-6 h-6 shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
            src={ICON_ARROW_UP}
            alt=""
            width={24}
            height={24}
          />
        </button>
      </div>

      {isExpanded ? (
        <div className="flex flex-col min-h-0">
          {(matches || []).map((match, idx) =>
            render(match, idx === (matches || []).length - 1),
          )}
        </div>
      ) : null}
    </div>
  );
}
